import * as ACTIONS from "./action_types";

const initialState = {
  fetching: false,
  success: false,
  failure: false,

  hints: [],
  gates: []
};

const hintsReducer = (state = { ...initialState }, { type, payload }) => {
  switch (type) {
    case ACTIONS.SET_PROCESSING:
      return {
        ...state,
        fetching: payload,
        success: false,
        failure: false,
      };
    case ACTIONS.FETCH_HINTS:
      return {
        ...state,
        fetching: false,
        success: true,
        failure: false,

        hints: payload,
      };
    case ACTIONS.FETCH_GATES:
      return {
        ...state,
        fetching: false,
        success: true,
        failure: false,

        gates: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default hintsReducer;
